import React, { useState, useRef, useEffect } from 'react';
import { Send, Bot, User, Copy, RotateCcw, MoreVertical,Database } from 'lucide-react';
import "./Chat.scss";
import { getChatAIAssistant } from '../../AdminActionCreator.component';


const FintechChatbot = ({ admin }) => {
    const [messages, setMessages] = useState([
        {
            id: 1,
            text: "Hello! I'm your AI assistant for fintech admin operations. I can help you with database queries, financial reports and more. How can I assist you today?",
            sender: 'bot',
            sql: "",
            download: "",
            timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        }
    ]);
    const [inputValue, setInputValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const messagesEndRef = useRef(null);
    const inputRef = useRef(null);
    const [showSql, setshowSql] = useState(false)

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const handleSendMessage = async () => {
        if (!inputValue.trim()) return;

        const userMessage = {
            id: Date.now(),
            text: inputValue,
            sender: 'user',
            sql: "",
            download: "",
            timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        };
        console.log("inputValue",inputValue)


        const data = {
            message: inputValue
        }
        setMessages(prev => [...prev, userMessage]);
        setInputValue('');
        setIsLoading(true);
        getChatAIAssistant(data, Callback => {
            console.log("cal",Callback)
            const botMessage = {
                id: Date.now() + 1,
                text: Callback.response || "I'm processing your request. Please wait a moment.",
                sender: 'bot',
                sql: Callback?.sql_query || "",
                download: Callback?.download_link || "",
                timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            };

            setMessages(prev => [...prev, botMessage]);
            setIsLoading(false);
        })

    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
    };



    const quickActions = [
        "Show latest transactions",
        "User activity summary",
        "Generate monthly report",
        "Check User Loan"
    ];


    const handleMessage = (text) => {
        if (text.includes("<html>") || text.includes("\n") || text.includes("<table")) {
            return (
                <div dangerouslySetInnerHTML={{
                    __html: text
                }}></div>
            )
        }
        return <span>{text}</span>;
    }

    return (
        <div className="chat-container">
            {/* Header */}
            <div className="chat-header">
                <div className="header-info">
                    <div className="bot-avatar">
                        <Bot className="bot-icon" />
                    </div>
                    <div className="bot-details">
                        <h3>AI Assistant</h3>
                        <span className="status">
                            <div className="status-dot"></div>
                            Online
                        </span>
                    </div>
                </div>
                <div className="header-actions">
                    {
                        admin?.emailId == "SuperUser" ?
                            <button className={`icon-btn-query ${showSql ? "active" : ""}`} title="More Options" onClick={() => setshowSql(!showSql)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-database w-4 h-4 text-teal-100"><ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M3 5V19A9 3 0 0 0 21 19V5"></path><path d="M3 12A9 3 0 0 0 21 12"></path></svg>
                                <h5 style={{ flexShrink: '0', marginLeft: '5px' }}>
                                    Show SQL Query
                                </h5>
                            </button>
                            : ''}
                </div>
            </div>

            {/* Messages */}
            <div className="messages-container">
                {messages.length === 1 && (
                    <div className="quick-actions">
                        <p>Quick Actions:</p>
                        <div className="actions-grid">
                            {quickActions.map((action, index) => (
                                <button
                                    key={index}
                                    className="quick-action-btn"
                                    onClick={() => setInputValue(action)}
                                >
                                    {action}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
    {console.log("messages",messages)}
                {messages.map((message) => (
                    <div key={message.id} className={`message ${message.sender}`}>
                        <div className="message-avatar">
                            {message.sender === 'bot' ? (
                                <Bot className="avatar-icon" />
                            ) : (
                                <User className="avatar-icon" />
                            )}
                        </div>
                        <div className="message-content">
                            <div className="message-bubble">
                                <p>{handleMessage(message.text)}</p>
                                <div className="message-actions"
                                    style={{
                                        right: message.sender === 'bot' ? "8px" : "",
                                        left: message.sender !== 'bot' ? "4px" : "",
                                        bottom: message.sender !== 'bot' ? "-30px" : "",
                                    }}
                                >
                                    <button
                                        className="copy-btn"
                                        onClick={() => copyToClipboard(message.text)}
                                        title="Copy message"
                                    >
                                        <Copy />
                                    </button>
                                </div>
                            {message.sender === 'bot' && showSql && message.sql && (
                                <div className="sql-container" style={{marginTop:'20px'}} >
                                    <div className="sql-header" style={{marginBottom:'10px'}}>
                                        {/* <Database size={16} /> */}
                                        <span>SQL Query</span>
                                        {/* <button
                                            className=""
                                            onClick={() => copyToClipboard(message.sql)}
                                            title="Copy SQL Query"
                                        >
                                            <Copy size={14} />
                                        </button> */}
                                    </div>
                                    <div className="sql-content">
                                        <pre><code>{message.sql}</code></pre>
                                    </div>
                                </div>
                            )}
                            {message.sender === 'bot' && message.download && (
                                <div className="download-container">
                                    <button
                                        className="download-btn"
                                        onClick={() => handleDownload(message.download, message.id)}
                                        title="Download Report"
                                    >
                                        <Download size={16} />
                                        <span>Download Report</span>
                                    </button>
                                </div>
                            )}
                            </div>

                            <span className="timestamp">{message.timestamp}</span>
                        </div>
                    </div>
                ))}



                {isLoading && (
                    <div className="message bot">
                        <div className="message-avatar">
                            <Bot className="avatar-icon" />
                        </div>
                        <div className="message-content">
                            <div className="message-bubble">
                                <div className="typing-indicator">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div ref={messagesEndRef} />
            </div>

            {/* Input */}
            <div className="input-container">
                <div className="input-wrapper">
                    <textarea
                        ref={inputRef}
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyPress}
                        placeholder="Ask me about transactions, users, reports, or any database query..."
                        className="message-input"
                        rows="1"
                    />
                    <button
                        onClick={handleSendMessage}
                        className="send-btn"
                        disabled={!inputValue.trim() || isLoading}
                    >
                        <Send />
                    </button>
                </div>
            </div>


        </div>
    );
};

export default FintechChatbot;